import White from '../../assets/images/Power Win.webp';
import Second from '../../assets/images/Triple Win.webp';
import Third from '../../assets/images/Double Win.webp';
import Q from '../../assets/icons/Query.svg';
import HowToPlay from '../../components/Popup/HowToPlay';
import { useState } from 'react';

export default function PrizeBanners() {
  const [playPopup, setPlayPopup] = useState(false);

  return (
    <>
      <div className='py-4 space-y-2'>
        {/* Main Prize Banner */}

        <div className='flex justify-end'>
          <button
            className='text-[10px] flex gap-1 text-white bg-[#652CC9] px-1 py-0.5 rounded-full '
            onClick={() => setPlayPopup(true)}
          >
            HOW TO PLAY <Q alt='apple' />
          </button>
        </div>

        <div className='flex justify-center'>
          <img src={White} alt='apple' />
        </div>

        <div className='flex justify-center gap-4'>
          <img src={Third} alt='apple' />
          <img src={Second} alt='apple' />
        </div>

        {/* Secondary Prize Banners */}
      </div>

      <HowToPlay
        isOpen={playPopup}
        onClose={() => setPlayPopup(false)}
      ></HowToPlay>
    </>
  );
}
